export default {
  emailValidationRules: [
    (v) => (!!v || "Email is required"),
    (v) => (/.+@.+\..+/.test(v) || "Invalid Email"),
  ],

  givenNameValidationRules: [
    (v) => (!!v || "Given Name is required"),
  ],

  passwordValidationRules: [
    (v) => (!!v || "Password is required"),
  ],

  surnameValidationRules: [
    (v) => (!!v || "Surname is required"),
  ],
};
